export const BoostBolt = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3_39194)">
      <rect width="34" height="34" rx="6.375" fill="#161616" />
      <rect
        width="34"
        height="34"
        rx="6.375"
        fill="url(#paint0_radial_3_39194)"
        fillOpacity="0.18"
      />
      <rect
        width="34"
        height="34"
        rx="6.375"
        fill="url(#paint1_radial_3_39194)"
        fillOpacity="0.18"
      />
      <g clipPath="url(#clip1_3_39194)">
        <g filter="url(#filter0_d_3_39194)">
          <path
            d="M15.6719 18.3279H11.4219L18.3281 9.29663V15.6716H22.5781L15.6719 24.7029V18.3279Z"
            fill="#FF33AF"
            fillOpacity="0.24"
            shapeRendering="crispEdges"
          />
          <path
            d="M15.6719 18.3279H11.4219L18.3281 9.29663V15.6716H22.5781L15.6719 24.7029V18.3279Z"
            stroke="url(#paint2_linear_3_39194)"
            strokeWidth="1.59375"
            strokeLinecap="round"
            strokeLinejoin="round"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <g opacity="0.5" filter="url(#filter1_f_3_39194)">
        <path
          d="M15.6719 18.3279H11.4219L18.3281 9.29663V15.6716H22.5781L15.6719 24.7029V18.3279Z"
          stroke="#FF33AF"
          strokeWidth="1.59375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <rect
      x="0.53125"
      y="0.53125"
      width="32.9375"
      height="32.9375"
      rx="5.84375"
      stroke="#75355c"
      strokeWidth="1.0625"
    />
    <defs>
      <filter
        id="filter0_d_3_39194"
        x="-106.887"
        y="-104.763"
        width="247.775"
        height="252.025"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4.25" />
        <feGaussianBlur stdDeviation="58.7562" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.2 0 0 0 0 0.686275 0 0 0 0.87 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3_39194" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3_39194" result="shape" />
      </filter>
      <filter
        id="filter1_f_3_39194"
        x="-5.1"
        y="-5.1"
        width="44.2"
        height="44.2"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="4.675" result="effect1_foregroundBlur_3_39194" />
      </filter>
      <radialGradient
        id="paint0_radial_3_39194"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17 -3.1875) rotate(90) scale(31.3438)"
      >
        <stop stopColor="#FF33AF" />
        <stop offset="1" stopColor="#FF33AF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_3_39194"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17 46.2188) rotate(-90) scale(34)"
      >
        <stop stopColor="#FFAFDF" />
        <stop offset="1" stopColor="#FF33AF" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint2_linear_3_39194"
        x1="17"
        y1="9.29663"
        x2="17"
        y2="24.7029"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF33AF" />
        <stop offset="0.302083" stopColor="#C22E88" />
        <stop offset="0.677083" stopColor="#FF75C9" />
        <stop offset="1" stopColor="#FF33AF" />
      </linearGradient>
      <clipPath id="clip0_3_39194">
        <rect width="34" height="34" rx="6.375" fill="white" />
      </clipPath>
      <clipPath id="clip1_3_39194">
        <rect width="25.5" height="25.5" fill="white" transform="translate(4.25 4.25)" />
      </clipPath>
    </defs>
  </svg>
);
